import React from 'react';
import { Link } from 'react-router-dom';

export const Footer = () => {
  const scrollTo = (id) => {
    const el = document.querySelector(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="bg-[#0A0817] border-t border-white/5 pt-16 pb-8" data-testid="footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10 mb-12">
          <div className="md:col-span-1">
            <Link to="/">
              <img
                src="https://customer-assets.emergentagent.com/job_verso-autoreports/artifacts/b11ds7pz_3.png"
                alt="VERSO SOFTECH"
                className="h-10 w-auto mb-4"
              />
            </Link>
            <p className="text-[#A8A3B8] text-sm leading-relaxed">
              Software de gestión para talleres mecánicos en Colombia.
            </p>
          </div>

          <div>
            <h4 className="font-caption text-xs uppercase tracking-[0.12em] text-white/60 mb-4">Producto</h4>
            <ul className="space-y-3">
              <li><button onClick={() => scrollTo('#producto')} className="text-[#A8A3B8] hover:text-white text-sm transition-colors">Talleres</button></li>
              <li><button onClick={() => scrollTo('#reportes')} className="text-[#A8A3B8] hover:text-white text-sm transition-colors">Reportes</button></li>
              <li><button onClick={() => scrollTo('#planes')} className="text-[#A8A3B8] hover:text-white text-sm transition-colors">Planes</button></li>
            </ul>
          </div>

          <div>
            <h4 className="font-caption text-xs uppercase tracking-[0.12em] text-white/60 mb-4">Contacto</h4>
            <ul className="space-y-3">
              <li>
                <a href="https://wa.me/573234041480" target="_blank" rel="noreferrer" className="text-[#A8A3B8] hover:text-white text-sm transition-colors">
                  WhatsApp
                </a>
              </li>
              <li>
                <a href="mailto:equipo@versosoftech.com" className="text-[#A8A3B8] hover:text-white text-sm transition-colors">
                  equipo@versosoftech.com
                </a>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="font-caption text-xs uppercase tracking-[0.12em] text-white/60 mb-4">Redes</h4>
            <ul className="space-y-3">
              <li>
                <a href="https://instagram.com/versosoftech" target="_blank" rel="noreferrer" className="text-[#A8A3B8] hover:text-white text-sm transition-colors">
                  Instagram @versosoftech
                </a>
              </li>
              <li>
                <a href="https://tiktok.com/@versosoftech" target="_blank" rel="noreferrer" className="text-[#A8A3B8] hover:text-white text-sm transition-colors">
                  TikTok
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/5 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-[#A8A3B8]/60 text-xs">
            VERSO SOFTECH S.A.S. · Tuluá, Valle del Cauca, Colombia
          </p>
          <p className="text-[#A8A3B8]/60 text-xs">
            © 2026 VERSO SOFTECH S.A.S. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>
  );
};
